import './Home.scss';

import paypalLogo from "./Assets/Paypal.jpg";


export default function Home()
{
    return(
        <div className='Page'>
            <h1>VG5000</h1>
            <p>
                Soyez les bienvenus sur ce site
            </p>
            <p>
                Le but de celui-ci est de vous aider à développer sur VG5000.<br/>
                Machine peu connue et peu performante, le VG5000 est un petit ordinateur 8 bits basé sur le célèbre Zilog Z80.
            </p>
            <p>
                Malheureusement pour cette machine, les concepteurs ont fait le choix d'utiliser comme processeur graphique un EF9345 de SGS-Thomson.
            </p>
            <p>
                Véritable purge, ce VDP (Vidéo Display Processor) accumule une conception bancale et une lenteur effective, faisant du VG5000 l'un des plus mauvais 8 bits à base de Z80.<br/>
                Malgrè la rapidité du Z80, vous vous retrouverez à attendre que le VDP réponde et accuse réception de vos ordres, perdant ainsi tout intêret.<br/>
                De plus, même si celui-ci fonctionne sur la base de gestion de caractères, sa conception réduira à néant cet avantage qui aurait dû permettre des animations rapides et fluides.<br/>
                Non, vraiment, le VG5000 n'a pas eu de chance.<br/>
                On notera aussi l'absence d'un processeur sonore, tare heureusement corrigée par des passionnés qui lui ont ajouté plusieurs extensions à base d'AY-3-8910, lui permettant enfin de jouer de jolies mélodies 
                comme on peut l'entendre sur Amstrad CPC, ZX spectrum ou MSX par exemple.
            </p>
            <p>
                J'ai acquis un Philips VG5000 il y a quelques années dans le but comme toujours d'évaluer quel 8bits à base de Z80 est le meilleur (ne cherchez pas c'est l'Amstrad CPC 6128+).<br/>
                Encouragé par T&J qui développait quelques jeux en Basic sur cette machine et par l'effervescence autour du groupe "<a href="https://www.facebook.com/groups/1161811471271807?locale=fr_FR" target="_blank" rel="noreferrer">Retro Programmers United for Obscure Systems</a>, 
                je décidais de me lancer à étudier la bête pour mieux la documenter.
            </p>
            <p>
                Au mois de Mars 2025, après des mois de torture, je sortais une première version d'un jeu entièrement codé en assembleur: <a href="https://bdciron.itch.io/patacaisse" target="_blank" rel="noreferrer">Patacaisse</a>.
            </p>
            <p>
                L'objectif atteint, il est donc désormais temps de partager mes connaissances sur la machine afin que tous en profitent et puissent à leur tour coder sur ce petit ordi.
            </p>
            <p>
                Me reste à vous souhaiter bon courage, et surtout bonne chance car la bête ne se laisse pas apprivoiser facilement.
            </p>
            <p>
            Ce site est fait principalement pour vous, mais l'hébergement n'est cependant pas gratuit.<br/>
            Aussi, si vous souhaitez m'aider, ou simplement m'encourager à continuer, une cagnotte sur Paypal est ouverte et vous pouvez y participer en cliquant sur l'image suivante:<br/>
            <a href="https://paypal.me/amauryz80" ><img className="paypal" src={paypalLogo} alt="Cagnotte Paypal"  /></a>
            </p>

        </div>

    )
}